var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldTick({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.265 5.83677L18.4733 2.91844C17.6658 2.62094 16.3483 2.62094 15.5408 2.91844L7.74917 5.83677C6.24751 6.40344 5.02917 8.1601 5.02917 9.76094V21.2359C5.02917 22.3834 5.78001 23.8993 6.70084 24.5793L14.4925 30.4018C15.8667 31.4359 18.1192 31.4359 19.4933 30.4018L27.285 24.5793C28.2058 23.8851 28.9567 22.3834 28.9567 21.2359V9.76094C28.9708 8.1601 27.7525 6.40344 26.265 5.83677ZM21.93 13.7701L15.8383 19.8618C15.6258 20.0743 15.3567 20.1734 15.0875 20.1734C14.8183 20.1734 14.5492 20.0743 14.3367 19.8618L12.07 17.5668C11.6592 17.1559 11.6592 16.4759 12.07 16.0651C12.4808 15.6543 13.1608 15.6543 13.5717 16.0651L15.1017 17.5951L20.4425 12.2543C20.8533 11.8434 21.5333 11.8434 21.9442 12.2543C22.355 12.6651 22.355 13.3593 21.93 13.7701Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldTick);
export default __webpack_public_path__ + "static/media/shield-tick.a2213cb9ad677eadc9ee71c7aff7c78a.svg";
export { ForwardRef as ReactComponent };